import React, { useContext } from "react";
import { Alert } from "react-bootstrap";
import {QuestionarioContext} from "../../../contexts/QuestionarioContext"
import { QuestionarioItem } from "./QuestionarioItem";

export function QuestionariosSection() {
    const { listaQuestionarios } = useContext(QuestionarioContext);

    return (
        <>
            <div className="mt-1">
                {listaQuestionarios?.length ? (
                    listaQuestionarios?.map((questionario, index) => {
                        return <QuestionarioItem key={index} questionario={questionario} />;
                    })
                ) : (
                    <Alert variant="info">
                        Não foi encontrada nenhum questionário cadastrado!!
                    </Alert>
                )}
            </div>
        </>
    );
}

